<template>
  <div>
    <RedteagoWeb v-if="!isMobile"></RedteagoWeb>
    <RedteagoMobile v-if="isMobile"></RedteagoMobile>
  </div>
</template>
<script>
import RedteagoWeb from './RedteaGo-web.vue'
import RedteagoMobile from './RedteaGo-mobile.vue'
export default {
  name: 'RedteaGo',
  data() {
    return {
      isMobile: true
    }
  },
  components: {
    RedteagoWeb,
    RedteagoMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
<style lang="less">
</style>
